// import { buildQuery } from '../lib/helper';
import client from '@/lib/http-client';

const endpoint = 'admin/supplier';

export default {
	getSupplierStatistic(params, cb, errorCb) {
		const url = `${endpoint}/statistic`;
		client.get(url, { params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	getSupplierReport(params, cb, errorCb) {
		const url = `${endpoint}/report`;
		client.get(url, { params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
